export const siteInfo = {
  name: '自慰方式完全指南',
  tagline: '安全、健康与愉悦的全面解析',
  description: '本网站围绕「自慰方式」提供科学、全面的健康指导，涵盖不同自慰方式的安全须知、卫生要点、心理健康影响及常见误区解答，帮助读者以正确、积极的态度了解自我身体，建立健康的性健康认知。',
  keywords: ['自慰方式', '安全自慰方式', '健康自慰方式', '自慰方式误区', '自慰方式卫生须知', '自慰方式与心理健康', '自慰方式常见问题'],
  url: 'https://mastinfo.github.io',
  logo: '自慰方式完全指南',
  foundingYear: '2024',
  email: 'contact@ziweifangshi.com',
  phone: '400-123-4567',
  address: '北京市朝阳区健康路100号',
};

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    sections: [
      {
        heading: '我们的使命',
        content: '「自慰方式完全指南」致力于成为中国最值得信赖的性健康教育平台之一。我们相信，科学的性知识是每个人应有的基本权利，去污名化的性教育是推动社会进步的重要力量。通过提供准确、全面、易于理解的性健康信息，我们帮助读者建立积极健康的性观念和自我认知。',
      },
      {
        heading: '我们的团队',
        content: '我们的内容团队由执业医师、心理咨询师、性教育专家和科普作者组成。每一篇文章都经过严格的医学审核，确保信息的科学性和准确性。我们坚持引用循证医学研究，避免传播未经证实的民间说法。',
      },
      {
        heading: '我们的价值观',
        content: '我们坚持科学、包容、尊重的核心价值观。我们相信身体的自主权，尊重每个人对身体探索的自由，同时强调安全和健康的重要性。我们反对任何形式的污名化和歧视，致力于营造一个开放、理性的性健康讨论空间。',
      },
    ],
  },
  reputation: {
    title: '口碑与认可',
    items: [
      {
        stat: '500万+',
        label: '累计阅读量',
        icon: 'ri-eye-line',
      },
      {
        stat: '98%',
        label: '读者满意度',
        icon: 'ri-heart-line',
      },
      {
        stat: '200+',
        label: '原创科普文章',
        icon: 'ri-article-line',
      },
      {
        stat: '50+',
        label: '合作医疗机构',
        icon: 'ri-hospital-line',
      },
    ],
    testimonials: [
      {
        quote: '这个网站用科学、客观的方式解答了我多年的困惑，让我对自己的身体有了全新的认识。感谢团队的用心付出。',
        author: '小琳，28岁，北京',
      },
      {
        quote: '作为家长，我一直不知道如何跟青春期的孩子谈性教育。这个网站的青少年性教育文章给了我很多启发和勇气。',
        author: '李先生，42岁，上海',
      },
      {
        quote: '专业的医学审核让我很放心。内容既科学严谨又通俗易懂，是我推荐给患者的重要健康资源。',
        author: '王医生，三甲医院妇产科',
      },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何关于性健康的问题、建议或合作意向，欢迎通过以下方式与我们联系。我们重视每一位读者的声音。',
    email: 'contact@ziweifangshi.com',
    phone: '400-123-4567',
    address: '北京市朝阳区健康路100号',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};